import { ControlsBackgroundType } from '../../components/ControlsBackground';
import { PlayerControlsDefinitions } from '../types';

export const defaultControls: PlayerControlsDefinitions = {
  actionIndicator: true,
  backgroundType: 'solid' as ControlsBackgroundType,
  basicInfo: true,
  centeredPlayPause: false,
  dismiss: false,
  fullscreen: false,
  playButtonTrapFocusDirections: [],
  playPause: true,
  settings: false,
  showBrandLogo: false,
  timeline: false,
  volume: true,
};
